module.exports = {
  id: 41,
  name: 'Pike Push-ups',
  categories: ['strength', 'arms', 'core', 'shoulders'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Strength',
  points: 25,
  instructions:
    'Pike push-ups build strong shoulders! Start on your hands and knees, then lift your hips up high like a mountain peak. Your head points down toward the ground. Then do push-ups!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready for pike push-ups? Let us build incredible shoulder strength!',
    },
    {
      time: 3,
      text: 'Start on your hands and knees, get ready to get strong!',
    },
    {
      time: 6,
      text: 'Lift your hips up high like a mountain peak, you are doing great!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Your head points down toward the ground!',
    },
    // SET 1 - 10 reps
    {
      time: 12,
      text: 'Perfect position! Your head points down toward the ground!',
    },
    {
      time: 15,
      text: 'Number 1! Lower your head down toward the ground, keep your core tight!',
    },
    {
      time: 18,
      text: 'Push back up with your shoulders and arms, stay strong!',
    },
    {
      time: 21,
      text: 'Number 2! Lower your head down with control, you are doing great!',
    },
    {
      time: 24,
      text: 'Push back up with your shoulders, keep going!',
    },
    {
      time: 27,
      text: 'Number 3! Lower your head down toward the ground, stay focused!',
    },
    {
      time: 30,
      text: 'Push back up with your arms and shoulders, you are strong!',
    },
    {
      time: 33,
      text: 'Number 4! Lower your head down with control, keep your core engaged!',
    },
    {
      time: 36,
      text: 'Push back up with your shoulders, you are doing amazing!',
    },
    {
      time: 39,
      text: 'Number 5! Lower your head down toward the ground, stay strong!',
    },
    {
      time: 42,
      text: 'Push back up with your arms and shoulders, keep going!',
    },
    {
      time: 45,
      text: 'Number 6! Lower your head down with control, you are doing great!',
    },
    {
      time: 48,
      text: 'Push back up with your shoulders, stay focused!',
    },
    {
      time: 51,
      text: 'Number 7! Lower your head down toward the ground, keep your core tight!',
    },
    {
      time: 54,
      text: 'Push back up with your arms and shoulders, you are strong!',
    },
    {
      time: 57,
      text: 'Number 8! Lower your head down with control, you are doing amazing!',
    },
    {
      time: 60,
      text: 'Push back up with your shoulders, keep going!',
    },
    {
      time: 63,
      text: 'Number 9! Lower your head down toward the ground, stay strong!',
    },
    {
      time: 66,
      text: 'Push back up with your arms and shoulders, you are doing great!',
    },
    {
      time: 69,
      text: 'Number 10! Lower your head down with control, almost there!',
    },
    {
      time: 72,
      text: 'Push back up with your shoulders, incredible work!',
    },
    {
      time: 75,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 78,
      text: 'Take a deep breath in and out, you are building incredible strength!',
    },
    {
      time: 81,
      text: 'Shake out your arms and shoulders, get ready for round two!',
    },
    {
      time: 84,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 87,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 10 reps
    {
      time: 90,
      text: 'Start on your hands and knees, then lift your hips up high like a mountain peak!',
    },
    {
      time: 93,
      text: 'Your head points down toward the ground, perfect position!',
    },
    {
      time: 96,
      text: 'Number 1! Lower your head down toward the ground, keep your core tight!',
    },
    {
      time: 99,
      text: 'Push back up with your shoulders and arms, stay strong!',
    },
    {
      time: 102,
      text: 'Number 2! Lower your head down with control, you are doing great!',
    },
    {
      time: 105,
      text: 'Push back up with your shoulders, keep going!',
    },
    {
      time: 108,
      text: 'Number 3! Lower your head down toward the ground, stay focused!',
    },
    {
      time: 111,
      text: 'Push back up with your arms and shoulders, you are strong!',
    },
    {
      time: 114,
      text: 'Number 4! Lower your head down with control, keep your core engaged!',
    },
    {
      time: 117,
      text: 'Push back up with your shoulders, you are doing amazing!',
    },
    {
      time: 120,
      text: 'Number 5! Lower your head down toward the ground, stay strong!',
    },
    {
      time: 123,
      text: 'Push back up with your arms and shoulders, keep going!',
    },
    {
      time: 126,
      text: 'Number 6! Lower your head down with control, you are doing great!',
    },
    {
      time: 129,
      text: 'Push back up with your shoulders, stay focused!',
    },
    {
      time: 132,
      text: 'Number 7! Lower your head down toward the ground, keep your core tight!',
    },
    {
      time: 135,
      text: 'Push back up with your arms and shoulders, you are strong!',
    },
    {
      time: 138,
      text: 'Number 8! Lower your head down with control, you are doing amazing!',
    },
    {
      time: 141,
      text: 'Push back up with your shoulders, keep going!',
    },
    {
      time: 144,
      text: 'Number 9! Lower your head down toward the ground, stay strong!',
    },
    {
      time: 147,
      text: 'Push back up with your arms and shoulders, you are doing great!',
    },
    {
      time: 150,
      text: 'Number 10! Lower your head down with control, almost there!',
    },
    {
      time: 153,
      text: 'Push back up with your shoulders, incredible work!',
    },
    {
      time: 156,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 159,
      text: 'Take a deep breath in and out, you are building incredible strength!',
    },
    {
      time: 162,
      text: 'Shake out your arms and shoulders, get ready for the final round!',
    },
    {
      time: 165,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 168,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 10 reps
    {
      time: 171,
      text: 'Start on your hands and knees, then lift your hips up high like a mountain peak!',
    },
    {
      time: 174,
      text: 'Your head points down toward the ground, perfect position!',
    },
    {
      time: 177,
      text: 'Number 1! Lower your head down toward the ground, keep your core tight!',
    },
    {
      time: 180,
      text: 'Push back up with your shoulders and arms, stay strong!',
    },
    {
      time: 183,
      text: 'Number 2! Lower your head down with control, you are doing great!',
    },
    {
      time: 186,
      text: 'Push back up with your shoulders, keep going!',
    },
    {
      time: 189,
      text: 'Number 3! Lower your head down toward the ground, stay focused!',
    },
    {
      time: 192,
      text: 'Push back up with your arms and shoulders, you are strong!',
    },
    {
      time: 195,
      text: 'Number 4! Lower your head down with control, keep your core engaged!',
    },
    {
      time: 198,
      text: 'Push back up with your shoulders, you are doing amazing!',
    },
    {
      time: 201,
      text: 'Number 5! Lower your head down toward the ground, stay strong!',
    },
    {
      time: 204,
      text: 'Push back up with your arms and shoulders, keep going!',
    },
    {
      time: 207,
      text: 'Number 6! Lower your head down with control, you are doing great!',
    },
    {
      time: 210,
      text: 'Push back up with your shoulders, stay focused!',
    },
    {
      time: 213,
      text: 'Number 7! Lower your head down toward the ground, keep your core tight!',
    },
    {
      time: 216,
      text: 'Push back up with your arms and shoulders, you are strong!',
    },
    {
      time: 219,
      text: 'Number 8! Lower your head down with control, you are doing amazing!',
    },
    {
      time: 222,
      text: 'Push back up with your shoulders, keep going!',
    },
    {
      time: 225,
      text: 'Number 9! Lower your head down toward the ground, stay strong!',
    },
    {
      time: 228,
      text: 'Push back up with your arms and shoulders, you are doing great!',
    },
    {
      time: 231,
      text: 'Number 10! Lower your head down with control, almost there!',
    },
    {
      time: 234,
      text: 'Push back up with your shoulders, incredible work!',
    },
    {
      time: 237,
      text: 'Incredible work! You are done! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 240,
      text: 'Amazing work! You did 30 pike push-ups and built incredible shoulder strength!',
    },
    {
      time: 243,
      text: 'Your shoulders are getting super strong! You are a strength champion!',
    },
    {
      time: 246,
      text: 'Great job, strength champion! You are building incredible power!',
    },
  ],
};
